import loadable from '@loadable/component';

export const GamesradarSiteWrapper = loadable(
  () => import(/* webpackChunkName: "gamesradar-site" */ './GamesradarSiteWrapper'),
);
